import { GenericStorage } from './storage'

/*
 * App theme can be used to infer the theme from storage without having to use async getters.
 * When a theme is checked, it should be assumed that dark theme is the exception and check for that or fallback to light theme.
 * The system theme will also fallback to light theme, if it is not dark.
 * We never check for the light theme, it is just the fallback when dark theme is not confirmed.
 */

export type ThemeType = 'light' | 'dark'

const storage = new GenericStorage<ThemeType>('APP_THEME')

export const get = (): ThemeType => storage.read() ?? getSystemTheme()
export const set = (theme: ThemeType) => storage.store(theme)
export const unset = () => storage.remove()
export const toggle = () => set(isDarkTheme() ? 'light' : 'dark')
export const isDarkTheme = () => get() === 'dark'
export const fromStorage = () => storage.read()

const getSystemTheme = () =>
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
